import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { SelectImageData, variant_type } from "../../../utils/common";
import { useNavigate } from "react-router";
import Header from "../../Header/Header";
import VarientSection from "./Varient";
import { useParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
library.add(fas);

const EditOffCanvance = (props) => {
  const navigate = useNavigate();

  // const id = props.show;
  const { id } = useParams();
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);
  const [countries, setCountries] = useState([]);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(
      `/admin/purchase-order/purchase-product/${id}`,
    );
    reset(response?.data);
  };

  const GetAllCategory = async () => {
    const response = await getData("/common/masters/all-p-category");

    if (response?.success) {
      setCountries(await Select2Data(response?.data, "p_category_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm();

  const Select3Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.name,
      variant_type_id: data?.variant_type_id,
      name: name,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };
  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");

    if (response?.success) {
      setProduct(await Select3Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);
  const watchQuantitys = watch("products");

  const [loader, setLoader] = useState(false);
  const onSubmit = async (data) => {
    try {
      setLoader(true);
      const DataToSend = new FormData();
      DataToSend.append("id", data?.id);
      let totalQuantity = 0;
      let totalPrice = 0;

      data?.products?.forEach((product) => {
        totalQuantity += Number(product?.receive_quantity || 0);
        totalPrice += Number(product?.total_price || 0);
      });
      DataToSend.append("total_quantity", totalQuantity);
      DataToSend.append("total_price", totalPrice);
      DataToSend.append("batch_no", data?.batch_no);
      // DataToSend.append("expiry_date", data?.expiry_date);
      DataToSend.append("supplier_id", data?.supplier_id?.value);

      const quantity = [];

      data.products.forEach((val) => {
        const qty = parseFloat(val?.receive_quantity) || 0;
        const price = parseFloat(val?.price) || 0;
        const total_price = parseFloat(val?.total_price) || 0;

        const quantityItem = {
          id: val?.id,
          product_id: val?.product_id?.value,
          quantity: qty,
          expiry_date: val?.expiry_date,
          price: price,
          total_price: total_price,
          varients: [],
        };

        // 🔹 VARIANTS
        val?.varients?.forEach((variant) => {
          const variantItem = {
            product_id: val?.product_id?.value,
            variant_id: variant?.varient_id,
            general_stock: variant?.general_stock || 0,
            selling_price: variant?.selling_price || 0,
            price: variant?.price || 0,

            double_variants: [],
          };

          // 🔹 DOUBLE VARIANTS
          variant?.double_variants?.forEach((doubleVar) => {
            const doubleItem = {
              d_variant_id: doubleVar?.d_variant_id,
              stock: doubleVar?.stock || 0,
              price: doubleVar?.price || 0,
              triple_variants: [],
            };

            // 🔹 TRIPLE VARIANTS
            doubleVar?.triple_variants?.forEach((tripleVar) => {
              doubleItem.triple_variants.push({
                t_variant_id: tripleVar?.t_variant_id,
                price: tripleVar?.price || 0,
                stock: tripleVar?.stock || 0,
              });
            });

            variantItem.double_variants.push(doubleItem);
          });

          quantityItem.varients.push(variantItem);
        });

        quantity.push(quantityItem);
      });


      DataToSend.append("products", JSON.stringify(quantity));

      const response = await putData(
        `/admin/purchase-order/purchase-product/receiving/${id}`,
        DataToSend,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        setLoader(false);
        navigate("/purchase-product/purchase-product");
        // props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "products",
  });

  const [supplier, setSupplier] = useState([]);
  const GetAllSupplier = async () => {
    const response = await getData("/common/masters/all-supplier");
    if (response?.success) {
      setSupplier(await Select2Data(response?.data, "supplier_id"));
    }
  };
  useEffect(() => {
    GetAllSupplier();
  }, []);

  const getProductStockAndPurchaseTotal = (product) => {
    const variantType = Number(product?.product_id?.variant_type_id);

    let totalStock = 0;
    let totalPurchasePrice = 0;

    // Single Variant
    if (variantType === variant_type.Single) {
      (product?.varients || []).forEach((variant) => {
        const stock = Number(variant?.general_stock || 0);
        const purchasePrice = Number(variant?.price || 0);

        totalStock += stock;
        totalPurchasePrice += stock * purchasePrice;
      });
    }

    // Double Variant
    if (variantType === variant_type.Double) {
      (product?.varients || []).forEach((variant) => {
        (variant?.double_variants || []).forEach((dvariant) => {
          const stock = Number(dvariant?.stock || 0);
          const purchasePrice = Number(dvariant?.price || 0);

          totalStock += stock;
          totalPurchasePrice += stock * purchasePrice;
        });
      });
    }

    // Triple Variant
    if (variantType === variant_type.Triple) {
      (product?.varients || []).forEach((variant) => {
        (variant?.double_variants || []).forEach((dvariant) => {
          (dvariant?.triple_variants || []).forEach((tvariant) => {
            const stock = Number(tvariant?.stock || 0);
            const purchasePrice = Number(tvariant?.price || 0);

            totalStock += stock;
            totalPurchasePrice += stock * purchasePrice;
          });
        });
      });
    }

    return {
      totalStock,
      totalPurchasePrice,
    };
  };
  const products = useWatch({
    control,
    name: "products",
  });
  useEffect(() => {
    if (!products?.length) return;

    products.forEach((product, index) => {
      const result = getProductStockAndPurchaseTotal(product);

      const totalStock = result?.totalStock || 0;
      const totalPrice = result?.totalPurchasePrice || 0;

      setValue(`products.${index}.receive_quantity`, totalStock, {
        shouldValidate: false,
        shouldDirty: false,
      });

      setValue(`products.${index}.total_price`, totalPrice, {
        shouldValidate: false,
        shouldDirty: false,
      });
    });
  }, [products, setValue]);

  return (
    <>
      <Header title={"Product Purchase Compare"} link={"#"} />
      <section className="Create">
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/purchase-product/purchase-product`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>

        <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
          <Row>
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="row justify-content-center mb-2">
                  <Form.Label>Supplier</Form.Label>

                  <Controller
                    name="supplier_id" // name of the field
                    {...register("supplier_id", {
                      required: "Select Supplier",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.supplier_id
                              ? "red"
                              : baseStyles,
                          }),
                        }}
                        {...field}
                        options={supplier}
                        // onChange={(selectedOption) => {
                        //   field.onChange(selectedOption.value); // Update Controller's value
                        //   GetAllStates(selectedOption.value);
                        //   setValue("country_id", selectedOption);
                        //   setValue("state_id", null);
                        // }}
                      />
                    )}
                  />

                  {errors.supplier_id && (
                    <span className="text-danger">
                      {errors.supplier_id.message}
                    </span>
                  )}
                </Row>
              </div>
            </Col>
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6> Receiving Quantity</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Product</Form.Label>
                            <Form.Group>
                              <Controller
                                name={`products.${index}.product_id`} // name of the field
                                {...register(`products.${index}.product_id`, {
                                  required: "Select Product",
                                })}
                                control={control}
                                render={({ field }) => (
                                  <Select
                                    isDisabled={true}
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        borderColor: errors?.add_on?.[index]
                                          ?.product_id
                                          ? "red"
                                          : baseStyles,
                                      }),
                                    }}
                                    {...field}
                                    options={product}
                                  />
                                )}
                              />
                              {errors?.products?.[index]?.product_id && (
                                <span className="text-danger">
                                  {errors.products[index].product_id.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Purchase Quantity</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`products.${index}.quantity`} // Register color for the variant
                                placeholder="Quantity"
                                readOnly
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.products?.[index]?.quantity,
                                })}
                                {...register(`products.${index}.quantity`, {
                                  required: "Quantity is required",
                                })}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors?.products?.[index]?.quantity && (
                                <span className="text-danger">
                                  {errors.products[index].quantity.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Recevie Quantity</Form.Label>
                            <Form.Group>
                              <Form.Control
                                // value={
                                //   getProductStockAndPurchaseTotal(
                                //     getValues(`products.${index}`),
                                //   ).totalStock
                                // }
                                type="text"
                                name={`products.${index}.receive_quantity`}
                                placeholder="Quantity"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.products?.[index]?.receive_quantity,
                                })}
                                {...register(
                                  `products.${index}.receive_quantity`,
                                  {
                                    required: "Quantity is required",
                                  },
                                )}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors?.products?.[index]?.receive_quantity && (
                                <span className="text-danger">
                                  {
                                    errors.products[index].receive_quantity
                                      .message
                                  }
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      {/* <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Price</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`products.${index}.price`} // Register color for the variant
                                placeholder="Quantity"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.products?.[index]?.price,
                                })}
                                {...register(`products.${index}.price`, {
                                  required: "price is required",
                                })}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors?.products?.[index]?.price && (
                                <span className="text-danger">
                                  {errors.products[index].price.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col> */}

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Total</Form.Label>
                            <Form.Group>
                              <Form.Control
                                // value={
                                //   getProductStockAndPurchaseTotal(
                                //     getValues(`products.${index}`),
                                //   ).totalPurchasePrice
                                // }
                                type="text"
                                name={`products.${index}.total_price`}
                                {...register(`products.${index}.total_price`, {
                                  required: "Total is required",
                                })}
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.products?.[index]?.total_price,
                                })}
                              />
                              {errors?.products?.[index]?.total_price && (
                                <span className="text-danger">
                                  {errors.products[index].total_price.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <VarientSection
                        product_id={getValues(`products.${index}.product_id`)}
                        Index={index}
                        control={control}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                    </Row>
                    {/* {fields.length > 1 && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => remove(index)} // Remove the variant
                        >
                          Remove Quantity
                        </button>
                      )} */}
                    <hr />
                  </div>
                ))}
                {/* <div>Total Quantity:{totalQuantity}</div>
                <div>Total Price:{totalPrice}</div> */}
              </div>
              <hr />
              {/* <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => append({})}
                  >
                    + Add Quantity
                  </button>
                </div> */}
            </div>

            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link to={"/purchase-product/purchase-product"}>
                  <CancelButton
                    name={"cancel"}
                    handleClose={props.handleClose}
                  />
                </Link>

                {loader ? (
                  <>
                    <Spinner
                      animation="border"
                      role="status"
                      variant="primary"
                      style={{ width: "25px", height: "25px" }}
                    />
                  </>
                ) : (
                  <>
                    <SaveButton
                      name={"save"}
                      handleSubmit={handleSubmit(onSubmit)}
                    />{" "}
                  </>
                )}
              </div>
            </Row>
          </Row>
        </Form>
      </section>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
